import React, { useEffect, useState } from "react";
import CarInfoCard from "pages/Fleet/Cars/ListView/CarInfoCard";
import _ from "lodash";

import {
    Container,
    Wrapper,
    ListViewWrapper,
    InnerList,
} from "pages/Fleet/Cars/ListView/ListViewStyled";

import {
    FLEET_GLOBAL_STATES,
    LIST_BY_GLOBAL_STATES,
    SITEID_GLOBAL_STATE,
    UPDATED_CAR_DATA_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import { isValidLocation } from "_helperFunctions/isValidLocation";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { isActionZoneAlert } from "_helperFunctions/isActionZoneAlert";
import { isStale } from "_helperFunctions/isStale";
import { isCritical } from "_helperFunctions/isCritical";
import { isAlertActionZone } from "_helperFunctions/isAlertActionZone";
import moment from "moment";
import { getFeatureSetOption, isUserAdmin, isUserSupport, isUserReadOnly, isUserBasic, getFeaturesList, memberCarTrackingLevel } from "constant";

export const ListView = React.memo(({ className, maxHeight, ...props }) => {
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
    const [featuresResortEdition] = React.useState(false);
    const [orderByState, setorderByState] = useState([]);
    const [carData, setCarData] = useState([]);

    const {
        toggleFleetCarList,
        fleetCarLength,
        fleetCarNumbers,
        fleetCarNumbersInvert,
    } = useHookstate(FLEET_GLOBAL_STATES);

    const {
        listBy,
        showFilterbattry,
        modeBy,
        showFilterServices,
        showFilterNotCommunicating,
        sortButton,
        memberCar,
    } = useHookstate(LIST_BY_GLOBAL_STATES);

    const { siteSettingsData, getCarPathActionZone, getUserRole, getSiteAreasState,
        getHoleAreasState } = useSelector((state) => state.commonReducers) || [];

    useEffect(() => {
        dispatch(COMMON_SERVICES.getCarServices(true, siteId.get())).then(
            (data) => {
                if (data && data?.length !== 0) {
                    setCarData(data);
                } else {
                    setCarData([]);
                }
            }
        );
        dispatch(COMMON_SERVICES.getSiteAreasServices(siteId.get()));
        dispatch(COMMON_SERVICES.getHoleAreasServices(siteId.get()));
    }, [siteId.get(), siteSettingsData]);

    useEffect(() => {
        if (
            updatedCarData.get() &&
            Object.keys(updatedCarData.get()).length !== 0
        ) {
            let localCarData = JSON.parse(updatedCarData.get());
            setCarData(localCarData);
        } else {
            setCarData([]);
        }
    }, [updatedCarData.get()]);

    useEffect(() => {
        dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
    }, [siteId.get()]);

    useEffect(() => {
        sortedData();
    }, [carData]);

    async function sortedData() {
        try {
            const orderBy = _.sortBy(carData, [(d) => d?.Car?.CarNumber]);
            setorderByState(orderBy);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getAllFilterData();
    }, [showFilterNotCommunicating.get()]);
    const pmid = (devType, packageManifestId) => {
        if (siteSettingsData) {
            var sitePMID = devType === 4 ? siteSettingsData.PackageManifestId : (devType === 8 ? siteSettingsData.V4ManifestSetId : '-');
            return (packageManifestId) ? packageManifestId : (sitePMID ? sitePMID : 'default');
        }
        else {
            return '-';
        }
    }
    const dev = (devType) => {
        switch (devType) {
            case 0: return '2.0';
            case 1: return 'G2';
            case 2: return '2.1';
            case 3: return 'FT';
            case 4: return '3.0';
            case 5: return 'LT';
            case 6: return 'WT';
            case 7: return 'FT2';
            case 8: return '4.0';
            default: return '?';
        }
    };
    const ctl = (ctl) => {
        switch (ctl) {
            case 1: return 'LIN';
            case 2: return 'CAN';
            case 3: return 'GCCM';
        }
    }

    let deviceType = {
        VDU: 0, // Tsunami VDU
        G2: 1, // G2
        VDU21: 2, // VDU 2.1
        FT: 3, // Fleet Tracker (e.g. Calamp)
        VDU3: 4, // VDU 3.0 (HW used with Android as OS)
        LT: 5,
        WT: 6, // Walker Tag
        FT2: 7, // FT+, aka ProDrive
        VDU4: 8, //VDU 4.0
    };

    let featureKey = {
        //FYI-Description as in DB commented to right, its whats shown to user
        carControl: "C", // Car control
        tracking: "T", // Real-time tracking
        golf: "G", // Golfer experience
        events: "E", // Tournament scoring
        flyovers: "V", // Flyovers
        adManager: "A", // AdMan Pro
        eventAdManager: "S", // AdMan Event
        resortEdition: "R", // Commercial
        sharkExpB2B: "X", // Shark Experience BtoB
        sharkExpB2C: "Y", // Shark Experience BtoC
        power: "P", // Shark Power
        sharkExpB2BL: "W", // Shark Experience BtoB Light
        foodBevAddon: "F", // Shark B2C F&B
        bluetooth: "B", // Bluetooth (note, this desc is modified in code based on product)
        sharkTrial: "Z", // Shark Trial
        sharkUpgrade: "U", // Shark Upgrades
        sharkMonthly: "M", // Shark Monthly Billing
        memberCars: "D", // Member Cars
        surveys: "Q", // Survey
        service: "H", // Service
        SelectBT: "J", // Select BT
        SelectPlus: "K", // Select+
        SelectPlusPlus: "L", // Select++
    };
    const getAllFilterData = () => {
        let _finalData = [];
        let data = [];
        let _returnListByData;
        if (!props.invert) {
            _returnListByData = returnListByData(orderByState, listBy.get());
            let getData = checkMultipleFilterData(_returnListByData);
            props.setCarListCount(getData?.length);

            if (getData.length === 0) props.setDisableSelectAll(true);
            else props.setDisableSelectAll(false);
            data = getData.map((item) => item?.Car?.CarNumber);
            fleetCarNumbers.set(data);
        } else {
            _returnListByData = returnListByData(
                orderByState,
                listBy.get() + "_invert"
            );
            let getData = checkMultipleFilterData(_returnListByData);
            props.setCarListCountInvert(getData?.length);

            if (getData.length === 0) props.setDisableSelectAllInvert(true);
            else props.setDisableSelectAllInvert(false);
            data = getData.map((item) => item?.Car?.CarNumber);
            fleetCarNumbersInvert.set(data);
        }
        _finalData = [..._returnListByData];
        let getData = checkMultipleFilterData(_finalData);
        _finalData = [...getData];
        _finalData && fleetCarLength.set(_finalData.length);

        _finalData = _finalData.filter(
            (tag, index, array) =>
                array.findIndex((t) => t.Car.CarNumber == tag.Car.CarNumber) == index
        );

        let _allData2 = [];
        let rowData = [];
        _finalData &&
            _finalData
                .filter((item) => {
                    if (props.getFleetcarsInput === "") {
                        return item;
                    } else if (
                        item?.Car?.CarNumber.toString()
                            .toLowerCase()
                            .includes(props.getFleetcarsInput.toLowerCase())
                    ) {
                        return item?.Car?.CarNumber;
                    }
                })
                .map((car, i) => {
                    rowData.push(
                        {
                            id: i + 1, Id: i,
                            car: car?.Car?.CarNumber,
                            gpsiID: car?.Car?.GpsiCarId,
                            battery: car?.Car,
                            location: car,
                            pace: car,
                            player1: car?.Car?.PlayerName1,
                            player2: car?.Car?.PlayerName2,
                            lastlocation: car?.Car?.LastLocationUpdateInUtc,
                            lastRT: car?.Car?.LastRTInUtc,
                            lastWiFi: car?.Car?.LastWiFiInUtc,
                            simCard: car?.Car?.SimCardNumber,
                            imei: car?.Car?.IMEI,
                            pmid: pmid(car?.Car?.DevType, car?.Car?.PackageManifestId),
                            vapp: car?.Car?.v2App,
                            vui: car?.Car?.v2Ui,
                            vlauncher: car?.Car?.v2Launcher,
                            gg: car?.Car?.AndroidGolfGeniusVersion,
                            aos: car?.Car?.AndroidOSVersion,
                            modemFW: car?.Car?.MFW,
                            microFW: car?.Car?.FSversion,
                            dev: dev(car?.Car?.DevType),
                            ctl: ctl(car?.Car?.CarControlType),
                            action: car,
                            icons: car
                        },
                    );
                    _allData2.push(
                        <CarInfoCard
                            key={car?.Car?.GpsiCarId}
                            cardata={car}
                            siteSettingsData={siteSettingsData}
                            actionZone={getCarPathActionZone}
                            id={i}
                        />
                    );
                });
        if (toggleFleetCarList.get() && toggleFleetCarList.get() == 2) {
            return <CarInfoCard
                siteSettingsData={siteSettingsData}
                actionZone={getCarPathActionZone}
                rows={rowData}
            />
        }
        else
            return _allData2;
    };
    const pointInPolygon = (point, polygon, longitudePropertyName, latitudePropertyName) => {
        var x = point[0], y = point[1];
        var inside = false;
        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i][longitudePropertyName], yi = polygon[i][latitudePropertyName];
            var xj = polygon[j][longitudePropertyName], yj = polygon[j][latitudePropertyName];

            var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    };
    const isCarInsideGeofence = (car) => {
        let actionZones = getCarPathActionZone?.filter((az) => {
            return az.IsGeofence;
        })
        if (!actionZones || Object.keys(actionZones).length <= 0) {
            return false;
        }
        var point = [car?.Car?.Longitude, car?.Car?.Latitude];
        var inside = pointInPolygon(point, actionZones[0].AzVertexes, 'Longitude', 'Latitude');
        return inside;
    }
    function isCarOnCourse(car) {
        let point = [car?.Car?.Longitude, car?.Car?.Latitude];
        for (let i = 0; i < getSiteAreasState?.length; i++) {
            if (pointInPolygon(point, getSiteAreasState[i]?.Polygon, "Lon", "Lat")) {
                return true;
            }
        }

        for (let i = 0; i < getHoleAreasState?.length; i++) {
            if (pointInPolygon(point, getHoleAreasState[i]?.Polygon, "Lon", "Lat"))
                return true;
        }
        return false;
    }
    const checkMultipleFilterData = (_returnSortByData) => {
        let filteredData = [..._returnSortByData];
        if (!sortButton.get()) {
            let getCharge = _returnSortByData.reverse();
            filteredData = [...getCharge];
        }
        if (
            !memberCar.get()
        ) {
            filteredData = filteredData.filter((car) => car?.Car?.CarType !== carType.member);
        }
        else if (!(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) {
            if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Never) {
                filteredData = filteredData.filter((car) => car?.Car?.CarType !== carType.member);
            }
            else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.InsideGeoFence) {
                filteredData = filteredData.filter((car) => {
                    if (car?.Car?.CarType === carType.member) {
                        return isCarInsideGeofence(car);
                    }
                    else
                        return true;
                }
                )
            }
            else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.OnCourseOrPlayingGolf) {
                filteredData = filteredData.filter((car) => {
                    if (car?.Car?.CarType === carType.member) {
                        if (car?.Car?.HolesPlayed && car?.Car?.HolesPlayed != 0)  // Can be called to filter CarTrackInfo lists which don't have one
                            return true;
                        else
                            return isCarOnCourse(car);
                    }
                    else
                        return true;
                }
                )
            }
        }
        if (
            showFilterServices.get() &&
            showFilterNotCommunicating.get() &&
            !showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => !car?.Car?.IsCharging);
        } else if (
            showFilterServices.get() &&
            !showFilterNotCommunicating.get() &&
            !showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => !isStale(car?.Car));
            filteredData = filteredData.filter((car) => !car?.Car?.IsCharging);
        } else if (
            showFilterNotCommunicating.get() &&
            !showFilterServices.get() &&
            !showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => car?.Car?.CarType !== 5);
            filteredData = filteredData.filter((car) => !car?.Car?.IsCharging);
        } else if (
            !showFilterNotCommunicating.get() &&
            !showFilterServices.get() &&
            showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => !isStale(car?.Car));
            filteredData = filteredData.filter((car) => car?.Car?.CarType !== 5);
        } else if (
            !showFilterNotCommunicating.get() &&
            showFilterServices.get() &&
            showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => !isStale(car?.Car));
        } else if (
            showFilterNotCommunicating.get() &&
            !showFilterServices.get() &&
            showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => car?.Car?.CarType !== 5);
        } else if (
            showFilterNotCommunicating.get() &&
            showFilterServices.get() &&
            showFilterbattry.get()
        ) {
        } else if (
            !showFilterNotCommunicating.get() &&
            !showFilterServices.get() &&
            !showFilterbattry.get()
        ) {
            filteredData = filteredData.filter((car) => !car?.Car?.IsCharging);
            filteredData = filteredData.filter((car) => !isStale(car?.Car));
            filteredData = filteredData.filter((car) => car?.Car?.CarType !== 5);
        } else if (!sortButton.get()) {
            let getCharge = _returnSortByData.sort((p1, p2) => {
                return p2?.Car?.CarNumber - p1?.Car?.CarNumber;
            });

            filteredData = [...getCharge];
        }
        return filteredData;
    };

    const actionZoneTextCheck = function (actionZoneId) {
        if (getCarPathActionZone) {
            let az = _.find(getCarPathActionZone, function (dcAZ) {
                return dcAZ.Id === actionZoneId;
            });
            if (az) {
                return az.Label ? true : false;
            }
        }
        return false;
    };

    const isStagingOrLockMode = () => {
        let guardianMode = {
            normal: 1,
            staging: 2,
            lockdown: 3,
        };
        return (
            siteSettingsData.GuardianCapable &&
            siteSettingsData.GuardianMode !== guardianMode.normal
        );
    };

    const returnListByData = (allData, filter) => {
        let filteredData = [];

        allData.map(async (car) => {
            if (filter === "NONE") {
                filteredData.push(car);
            } else if (filter === "CHARGING") {
                if (car?.Car?.IsCharging) {
                    filteredData.push(car);
                }
            } else if (filter === "MEMBER CARS") {
                if (car?.Car?.CarType === carType?.member && car?.Car?.SecondaryCarType !== carType.handicap && memberCar.get()) {
                    filteredData.push(car);
                }
            } else if (filter === "CHARGING_invert") {
                if (!car?.Car?.IsCharging) {
                    filteredData.push(car);
                }
            } else if (filter === "MEMBER CARS_invert") {
                if (!(car?.Car?.CarType === carType?.member && car?.Car?.SecondaryCarType !== carType.handicap && memberCar.get())) {
                    filteredData.push(car);
                }
            }
            else if (filter === "CAR") {
                if (car?.Car?.IsCharging) {
                    filteredData.push(car);
                }
            } else if (filter === "ALERTS") {
                if (
                    isAlertActionZone(car?.Car) ||
                    car?.Car?.MaxHolesExceeded ||
                    (siteSettingsData?.Features.indexOf(featureKey.power) >= 0 &&
                        (car?.Car?.hasChargeAlert || isCritical(car?.Car))) ||
                    isActionZoneAlert(getCarPathActionZone, car?.Car?.ActionZoneId)
                ) {
                    filteredData.push(car);
                }
            } else if (filter === "ALERTS_invert") {
                if (
                    (isAlertActionZone(car?.Car) ||
                        car?.Car?.MaxHolesExceeded ||
                        (siteSettingsData?.Features.indexOf(featureKey.power) >= 0 &&
                            (car?.Car?.hasChargeAlert || isCritical(car?.Car))) ||
                        isActionZoneAlert(getCarPathActionZone, car?.Car?.ActionZoneId)) ===
                    false
                ) {
                    filteredData.push(car);
                }
            } else if (filter === "PACE") {
                if (car?.Car?.HasMoved == false) {
                    filteredData.push(car);
                }
            } else if (filter === "PACE_invert") {
                if (!car?.Car?.HasMoved == false) {
                    filteredData.push(car);
                }
            } else if (filter === "IN USE") {
                if (isCarInUse(car)) filteredData.push(car);
            } else if (filter === "IN USE_invert") {
                if (!isCarInUse(car)) filteredData.push(car);
            } else if (filter === "BATTERY") {
                if (car?.Car?.HasMoved) {
                    filteredData.push(car);
                }
            } else if (filter === "BATTERY_invert") {
                if (!car?.Car?.HasMoved) {
                    filteredData.push(car);
                }
            } else if (filter === "ACTION ZONE") {
                if (actionZoneTextCheck(car?.Car?.ActionZoneId)) {
                    filteredData.push(car);
                }
            } else if (filter === "ACTION ZONE_invert") {
                if (!actionZoneTextCheck(car?.Car?.ActionZoneId)) {
                    filteredData.push(car);
                }
            } else if (filter === "STAGED") {
                if (
                    modeBy.get() !== "NORMAL" &&
                    ((car?.GuardianCapable !== false && !car?.Car.AllowedToMove) ||
                        (!car?.Car.HasMoved && isStagingOrLockMode()))
                )
                    filteredData.push(car);
            } else if (filter === "STAGED_invert") {
                if (modeBy.get() === "NORMAL") {
                    filteredData.push(car);
                } else if (
                    (car?.GuardianCapable !== true && car?.Car.AllowedToMove) ||
                    (car?.Car.HasMoved && !isStagingOrLockMode())
                ) {
                    filteredData.push(car);
                }
            }
        });

        return filteredData;
    };
    const carType = {
        normal: 1,
        marshal: 2,
        handicap: 3,
        bevcart: 4,
        outOfService: 5,
        member: 6,
    };
    const holeLocation = {
        unknown: 0,
        betweenHoles: 1,
        tee: 2,
        fairway: 3,
        green: 4,
    };

    let staleTimeInMinutes = 15;

    function isCarInUse(car, includeNotPlaying, includeNoComm, includeCharging) {
        // If marked out-of-service, never count as in use
        if (car?.Car?.CarType === carType.outOfService) return false;
        // Must have reported position within last XX minutes to count
        let ageInMinutes = moment().diff(
            moment.utc(car?.Car?.LastLocationUpdateInUtc),
            "minutes"
        ); // JFG: I don't think .utc is necessary here
        if (ageInMinutes > staleTimeInMinutes) return false;

        if (
            car?.Car?.DevType !== deviceType.FT ||
            car?.Car?.DevType !== deviceType.WT
        ) {
            // For all cars, must be off charge and have a valid lat/long
            if (
                car?.Car?.IsCharging ||
                !isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)
            )
                return false;

            if (featuresResortEdition) {
                // For regular and special needs car, must have a guest name and/or suite assigned to count as "in use"
                if (
                    car?.Car?.CarType !== carType?.marshal &&
                    car?.Car?.CarType !== carType?.bevcart
                )
                    if (!car?.Car?.PlayerName1 && !car?.Car?.PlayerName2) return false;
            } else {
                // For regular golfers and special needs, must be on a hole to count as "in use"
                if (
                    car?.Car?.HoleLocation === holeLocation.unknown &&
                    car?.Car?.CarType !== carType.marshal &&
                    car?.Car?.CarType !== carType.bevcart
                )
                    return false; // not on hole, not a marshal, not a beverage cart === not in use
            }
        } else {
            if (!isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)) {
                return false;
            }
        }

        return true; // in use!
    }
    function getActionZoneLabel(azID) {
        if (getCarPathActionZone && getCarPathActionZone.length !== 0) {
            var az = _.find(getCarPathActionZone, function (dcAZ) {
                return dcAZ.Id === azID;
            });
            if (az) {
                return az.Label ? az.Label : "";
            }
        }
        return "";
    }

    return (
        <Container>
            <Wrapper className={className} style={{ maxHeight: maxHeight }}>
                {toggleFleetCarList.get() == 0 && (
                    <ListViewWrapper>
                        <InnerList>{getAllFilterData()}</InnerList>
                    </ListViewWrapper>
                )}

                {toggleFleetCarList.get() && toggleFleetCarList.get() == 1 ? (
                    <ListViewWrapper>
                        <InnerList className="grid-view-outer-div">
                            {getAllFilterData()}
                        </InnerList>
                    </ListViewWrapper>
                ) : (
                    <></>
                )}
                {toggleFleetCarList.get() && toggleFleetCarList.get() == 2 ? (
                    <ListViewWrapper className="table-ui" >
                        {getAllFilterData()}
                    </ListViewWrapper>
                ) : (<></>)}
            </Wrapper>
        </Container>
    );
});
